import styled from 'styled-components';

import { mediaSmallOrTiny } from '@xing-com/layout-tokens';
import { space4XL, space5XL } from '@xing-com/tokens';

const Wrapper = styled.section`
  margin-top: ${space5XL};

  @media ${mediaSmallOrTiny} {
    margin-top: ${space4XL};
  }
`;

export const Styled = {
  Wrapper,
};
